import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const ADMIN_EMAIL = 'artachobruno@gmail.com';

interface RequireAdminProps {
  children: ReactNode;
}

/**
 * RequireAdmin wraps RequireAuth-protected routes that should only
 * be accessible to the admin user. Non-admin users are redirected
 * to /today.
 */
export function RequireAdmin({ children }: RequireAdminProps) {
  const { user } = useAuth();

  if (user && user.email !== ADMIN_EMAIL) {
    return <Navigate to="/today" replace />;
  }

  return <>{children}</>;
}
